import { render } from "./xtx-button.vue?vue&type=template&id=1e3a5560&scoped=true"
import script from "./xtx-button.vue?vue&type=script&lang=js"
export * from "./xtx-button.vue?vue&type=script&lang=js"

import "./xtx-button.vue?vue&type=style&index=0&id=1e3a5560&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3a5560"]])

export default __exports__